import React, { memo } from 'react';
import { User } from 'lucide-react';
import { ICON_PX } from '../../ui';

/**
 * Swimlane container node — renders as a labeled background region.
 * Used as a ReactFlow Group node that contains task/gate/etc. children.
 *
 * This is a visual-only container; it doesn't have handles because
 * edges connect to the child nodes inside it.
 */
function SwimlaneNode({ data }) {
  const { label, role } = data;

  return (
    <div
      className="rounded-xl border border-dashed border-slate-200 bg-slate-50/40 min-w-[280px] min-h-[120px] w-full h-full"
      style={{ padding: '8px' }}
    >
      {/* Lane header */}
      <div className="flex items-center gap-1.5 px-3 py-1.5 mb-2 bg-white/80 rounded-lg border border-slate-100 w-fit">
        <User size={ICON_PX.sm} className="text-slate-400" />
        <span className="text-xs font-semibold text-slate-600 uppercase tracking-wide">
          {label || 'Unassigned'}
        </span>
        {role && (
          <span className="text-[10px] text-slate-400 ml-1">({role})</span>
        )}
      </div>
    </div>
  );
}

export default memo(SwimlaneNode);
